import { useEffect } from 'react';
import { useLocation, useMatches } from 'react-router-dom';
import { useRum } from 'src/components/rumProvider';

export const useRumPageTracking = (): void => {
  const location = useLocation();
  const matches = useMatches();
  const { recordPageView, recordEvent } = useRum();

  useEffect(() => {
    const lastMatch = matches.at(-1);
    if (!lastMatch) return;

    // Replace each dynamic param value with its :key placeholder so RUM groups
    // equivalent pages together (e.g. /assemblies/details/:assemblyId).
    const pageId = Object.entries(lastMatch.params).reduce(
      (path, [key, value]) => (value ? path.replace(value, `:${key}`) : path),
      location.pathname,
    );

    // Override the SDK's auto-tracked page ID (which includes query-string params
    // from the hash, e.g. /ui/cc-ui/#/assemblies?sort=…) with this normalised,
    // param-stripped ID so LCP/FID are attributed to a stable, filterable key.
    recordPageView(pageId);
    recordEvent('PageContext', { pageId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
};
